<template>
  <div v-if="event" class="event-stats">
    <h1>
      <span class="title">{{ $t('Stats') }}</span>
      <span class="provider">{{ $t('PoweredBy') }} <span>{{ $t('Number') }}<strong>{{ $t('Fire') }}</strong></span></span>
    </h1>

    <div v-if="statsAvailable" class="stats-data">
      <div class="record head" :class="{'team-logos': teamLogoVisibility}">
        <div class="away cell">
          <span v-if="showparticipantlogo" class="team-logo" :style="awayTeamLogoStyle"></span>
          <span class="name">{{ nameAway }}</span>
        </div>
        <div class="time-location cell">
          <span class="at">@</span>
          <span class="date">{{ date }}</span>
          <span class="time">{{ time }}</span>
          <span class="location"></span>
        </div>
        <div class="home cell">
          <span v-if="showparticipantlogo" class="team-logo" :style="homeTeamLogoStyle"></span>
          <span class="name">{{ nameHome }}</span>
        </div>
      </div>

      <div class="record result">
        <div class="away cell">{{ awayParticipantAgainstTheSpreadRecord }}</div>
        <div class="description cell">{{ $t('Stats.AgainstTheSpreadRecord') }}</div>
        <div class="home cell">{{ homeParticipantAgainstTheSpreadRecord }}</div>
      </div>

      <div class="record result">
        <div class="away cell">{{ awayParticipantStatsWhenPlayingAway }}</div>
        <div class="description cell">{{ $t('Stats.HomeVsAwayRecord') }}</div>
        <div class="home cell">{{ homeParticipantStatsWhenPlayingHome }}</div>
      </div>

      <div class="record result">
        <div class="away cell">{{ awayParticipantWinProbability }}</div>
        <div class="description cell">{{ $t('Stats.WinProbability') }}</div>
        <div class="home cell">{{ homeParticipantWinProbability }}</div>
      </div>

      <div class="record result">
        <div class="away cell">{{ awayParticipantOverUnderRecord }}</div>
        <div class="description cell">{{ $t('Stats.OverUnderRecord') }}</div>
        <div class="home cell">{{ homeParticipantOverUnderRecord }}</div>
      </div>

      <div class="record result">
        <div class="away cell">{{ awayParticipantAveragePointsForPerGame }}</div>
        <div class="description cell">{{ $t('Stats.AveragePointsForPerGame') }}</div>
        <div class="home cell">{{ homeParticipantAveragePointsForPerGame }}</div>
      </div>

      <div class="record result">
        <div class="away cell">{{ awayParticipantAveragePointsAgainstPerGame }}</div>
        <div class="description cell">{{ $t('Stats.AveragePointsAgainstPerGame') }}</div>
        <div class="home cell">{{ homeParticipantAveragePointsAgainstPerGame }}</div>
      </div>
    </div>
    <div v-else class="stats-data no-stats">
      <span class="text">{{ $t('NoStats') }}</span>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'

  import ParticipantInfos from '@/components/mixins/ParticipantInfos'
  import BettingOffer from '@/components/mixins/BettingOffer'
  import TeamLogo from '@/components/mixins/TeamLogo'
  import Brands from '@/components/mixins/Brands'
  import Icon from '@/components/common/Icon'

  export default {
    name: 'EventStats',

    mixins: [
      ParticipantInfos,
      BettingOffer,
      TeamLogo,
      Brands
    ],

    components: {
      Icon
    },

    props: [
      'event'
    ],

    data () {
      return {
      }
    },

    computed: {
      nameAway () {
        return this.event.participantnameaway
      },
      nameHome () {
        return this.event.participantnamehome
      },
      teamLogos () {
        return {
          logoHome: this.event.logohome,
          logoAway: this.event.logoaway
        }
      },
      date () {
        if (this.isToday) {
          return this.$t('Today')
        } else if (this.isTomorrow) {
          return this.$t('Tomorrow')
        } else {
          return moment(this.event.tsExpectedStart).format(this.dateFormats.dayName)
        }
      },
      time () {
        return moment(this.event.tsExpectedStart).format(this.dateFormats.shortTime) + ' ' + moment(this.event.tsExpectedStart).format('A')
      },
      liveEventAppearsOnScreen () {
        return this.event.isliveevent && this.event.idfobolifestate === 'O'
      },
      showparticipantlogo () {
        return this.current_brand_cnfiguration.showParticipantLogos
      }
    },

    methods: {
    }
  }
</script>

<style lang="stylus" scoped>
  @import '~@/css/config'
</style>



// WEBPACK FOOTER //
// src/components/cdu/EventStats.vue